import { render } from "./KryptonDoRegister.vue?vue&type=template&id=9959eb7e&lang=pug"
import script from "./KryptonDoRegister.vue?vue&type=script&lang=js"
export * from "./KryptonDoRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__